var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12.281,
    viewBox: "0 0 14 12.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "swap",
    d: "M0-8.75v-.219A.29.29,0,0,1,.328-9.3h2.9a.34.34,0,0,1,.246.109L5.906-6.535l-.6.629L2.98-8.422H.328A.29.29,0,0,1,0-8.75ZM13.754-1.121,12,.629a.8.8,0,0,1-.957.178A.817.817,0,0,1,10.5,0V-1.2H9.789a.26.26,0,0,1-.219-.109L7.109-3.965l.6-.629,2.324,2.516H10.5V-3.5a.817.817,0,0,1,.547-.807A.8.8,0,0,1,12-4.129l1.75,1.75A.913.913,0,0,1,14-1.75.913.913,0,0,1,13.754-1.121Zm-.547-.711-1.75-1.75a.106.106,0,0,0-.123-.027.106.106,0,0,0-.068.109V0a.106.106,0,0,0,.068.109.106.106,0,0,0,.123-.027l1.75-1.75A.1.1,0,0,0,13.207-1.832Zm.547-6.289L12-6.371a.8.8,0,0,1-.957.178A.817.817,0,0,1,10.5-7V-8.422h-.465L3.473-1.312a.34.34,0,0,1-.246.109H.328A.29.29,0,0,1,0-1.531V-1.75a.29.29,0,0,1,.328-.328H2.98L9.543-9.187A.34.34,0,0,1,9.789-9.3H10.5v-1.2a.817.817,0,0,1,.547-.807.8.8,0,0,1,.957.178l1.75,1.75A.913.913,0,0,1,14-8.75.913.913,0,0,1,13.754-8.121Zm-.547-.711-1.75-1.75a.106.106,0,0,0-.123-.027.106.106,0,0,0-.068.109V-7a.106.106,0,0,0,.068.109.106.106,0,0,0,.123-.027l1.75-1.75A.1.1,0,0,0,13.207-8.832Z",
    transform: "translate(0 11.391)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.b3c508602b90456538c26fd848d46ed7.svg";
export { ForwardRef as ReactComponent };